/** Opaque identifier. Identity is always by id, never by name (duplicate names are allowed). */
export type Id = string;

export interface Rating {
  id: Id;
  name: string;
  /** `#RRGGBB`, upper-case. */
  color: string;
}

/** A role/perspective within a category, e.g. "Giving" / "Receiving" (v2: "subcategory"). */
export interface Role {
  id: Id;
  name: string;
}

export interface Kink {
  id: Id;
  name: string;
  /** Role id → rating id. Exactly one entry per role of the owning category. */
  ratings: Record<Id, Id>;
  comment?: string;
}

export interface Category {
  id: Id;
  name: string;
  roles: Role[];
  kinks: Kink[];
  collapsed?: boolean;
}

export interface KinklistDoc {
  v: 3;
  /** The owner's name (v2: "username"). */
  title: string;
  /** `ratings[0]` is the implicit "unset" rating. Always at least two. */
  ratings: Rating[];
  categories: Category[];
  /** ISO timestamp of the last change. */
  updatedAt: string;
}

export const LIMITS = {
  /** Category, role, kink and rating names. */
  name: 80,
  comment: 2000,
  title: 60,
  minRatings: 2,
  minRoles: 1,
  maxRoles: 4,
} as const;
